import { render, staticRenderFns } from "./edit-gasthreshold.vue?vue&type=template&id=7a84fd82&"
import script from "./edit-gasthreshold.vue?vue&type=script&lang=ts&"
export * from "./edit-gasthreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports